import { render, staticRenderFns } from "./Ljsy.vue?vue&type=template&id=0d565a45&scoped=true&"
import script from "./Ljsy.vue?vue&type=script&lang=js&"
export * from "./Ljsy.vue?vue&type=script&lang=js&"
import style0 from "./Ljsy.vue?vue&type=style&index=0&id=0d565a45&lang=less&scoped=true&"
import style1 from "./Ljsy.vue?vue&type=style&index=1&id=0d565a45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d565a45",
  null
  
)

export default component.exports